export default __webpack_public_path__ + "4b28b85c71fa2ec4b0b8eb658447602c.png";